export class UnitUtils {

  public static convertLongFromService(value: string): string {

    // check if empty
    if (value === '') {
      return '' + value;
    }

    try {
      // check if number
      if (Number.isNaN(Number(value))) {
        return '';
      }

      const CENT_DIVIDER = 100;
      value = String(Number(value) / CENT_DIVIDER);

    } catch (e) {
      throw new Error(`Can't cast value ${value} to Number`);
    }

    return value;
  }

}
